module.exports = __webpack_public_path__ + "static/img/mengzhengfile.0f05e1a.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/mengzhengfile.png
// module id = VIMs
// module chunks = 3